module.exports = __webpack_public_path__ + "static/img/MT.310b792a.jpg";